import React from "react";
import { Link } from "react-router-dom";
import cpImg from "../Assets/img/course/cp-img.png";
import pbImg from "../Assets/img/course/pb-img.png";
import Rectangle from "../Assets/img/course/Rectangle 1027.png";
import dsImg from "../Assets/img/course/ds-img.png";
import wdImg from "../Assets/img/course/wd-img.png";
import useMedia from "../componentsofcourse/useMedia";
import Programming from "./cProgramming";
import ProgrammingMobile from "./cProgrammingMobile";
function Course() {
	const matches = useMedia("(min-width : 768px )");

	return (
		<div id="MOVEHERE">
			{matches ? <Programming /> : <ProgrammingMobile />}
		</div>
	);
}

export default Course;
